export default {"src":"/_next/static/media/CompletedCourses.0d5a478f.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};